import { useWindowWidth } from '@react-hook/window-size'
import {
  Anchor,
  Button,
  Div,
  DropDownMenu,
  Flex,
  Icon,
  LinkColumnType,
} from '@sendoutcards/quantum-design-ui'
import React, { useState } from 'react'
import { openApp } from 'src/helpers/appHelpers'

const AccountSection: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const width = useWindowWidth()
  const isMobile = width < 600

  const joinLink = `https://www.sendoutcards.com/app/pricing`

  const mobileDropdownLinks: LinkColumnType = {
    title: 'My Account',
    links: [
      {
        title: 'Login',
        href: '#',
        onClick: () => openApp('/dashboard/account', { client: 'soc' }),
      },
      { title: 'Join Now', href: joinLink },
    ],
  }

  return isMobile ? (
    <Flex position="relative">
      <Icon name="user" size="xSmall" primaryColor="primaryBodyText" />
      <Icon
        name={'chevron'}
        orientation={isDropdownOpen ? 'up' : 'down'}
        size={'small'}
        onClick={() => {
          setIsDropdownOpen(!isDropdownOpen)
        }}
        primaryColor={'primaryBodyText'}
      />
      <DropDownMenu
        right={-24}
        top={48}
        isOpen={isDropdownOpen}
        linkColumn={mobileDropdownLinks}
      />
    </Flex>
  ) : (
    <Div width="200px">
      <Flex columnGap="x2">
        <Button
          size="xSmall"
          type="shadow"
          hover={true}
          onClick={() => openApp('/dashboard/account', { client: 'soc' })}
        >
          Login
        </Button>
        <Anchor href={joinLink} style={{ textDecoration: 'none' }}>
          <Button hover={true} outlined={true} size="xSmall">
            Join Now
          </Button>
        </Anchor>
      </Flex>
    </Div>
  )
}

export default AccountSection
